import { defineMessages } from 'react-intl';

type Message = {
	id: string;
	defaultMessage: string;
	description: string;
};

export const messages: {
	moreApps: Message;
	findApps: Message;
	connect: Message;
	discoverMoreApps: Message;
} = defineMessages({
	moreApps: {
		id: 'search-page.search-page-relay.filters.refresh-filter-row.more-apps.moreApps',
		defaultMessage: 'More apps',
		description: 'Accessible name for the dropdown listing every app that can be filtered by.',
	},
	findApps: {
		id: 'search-page.search-page-relay.filters.refresh-filter-row.more-apps.findApps',
		defaultMessage: 'Find apps',
		description: 'Placeholder for the search input in the More apps filter dropdown.',
	},
	connect: {
		id: 'search-page.search-page-relay.filters.refresh-filter-row.more-apps.connect',
		defaultMessage: 'Connect',
		description:
			'Label next to an unconnected third-party app in the More apps dropdown; selecting it starts the connect flow.',
	},
	discoverMoreApps: {
		id: 'search-page.search-page-relay.filters.refresh-filter-row.more-apps.discoverMoreApps',
		defaultMessage: 'Discover more apps',
		description:
			'Footer item in the More apps dropdown; opens Rovo settings where more apps can be connected.',
	},
});
